import tw, { styled } from 'twin.macro';
import { ImageElement } from '@kontent-ai/gatsby-components';
import Icon from '@/components/Icon/IconAsset';

export const StyledLink = styled.a`
  ${tw`relative`}
  ${tw`flex flex-col`}
  ${tw`px-1 py-[4px]`}

  &:before {
    ${tw`absolute`}
    ${tw`content-['']`}
    ${tw`bg-ui-colours-ui1`}
    ${tw`w-full`}
    ${tw`h-full`}
    ${tw`-top-0 -left-0`}
    ${tw`rounded`}
    ${tw`opacity-0`}
    ${tw`transition-opacity duration-300 ease-out`}
    ${tw`pointer-events-none`}
  }

  &:hover:before {
    ${tw`opacity-100`}
  }

  &:focus {
    ${tw`outline-none`}
  }

  &:focus-visible,
  &[aria-current='true'] {
    outline: 2px solid #126ed3;
    outline-offset: 0;
    border-radius: 3px;
  }
`;

export const StyledTitle = styled.span`
  ${tw`flex items-center flex-wrap gap-x-[6px] gap-y-[5px]`}
  ${tw`relative`}
  ${tw`font-semi-bold font-poppins`}
  ${tw`text-tag-l`}
  ${tw`text-primary-p1`}
`;

export const StyledImage = styled(ImageElement)`
  ${tw`w-[176px]`}
  ${tw`mb-1`}
`;

export const StyledDescription = styled.span`
  ${tw`relative`}
  ${tw`font-inter font-regular`}
  ${tw`text-body-s text-primary-p1 `}
  ${tw`mt-[4px]`}
  ${tw`text-left`}
`;

export const StyledIcon = styled(Icon)`
  ${tw`inline`}
  ${tw`h-[18px] w-[18px]`}
  ${tw`mr-1`}
`;
